import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import classNames from 'classnames';
import { useAppContext } from '@/Main';
import type { ReactNode } from 'react';

interface CardDropdownProps {
  viewUrl?: string;
  btnRevealClass?: string;
  drop?: 'up' | 'down' | 'start' | 'end';
  children?: ReactNode;
  iconEl?: ReactNode;
  icon?: IconProp;
}

const CardDropdown = ({
  btnRevealClass,
  drop,
  children,
  iconEl,
  icon = 'ellipsis-h',
}: CardDropdownProps) => {
  const {
    config: { isRTL },
  } = useAppContext();

  return (
    <Dropdown
      className="font-sans-serif btn-reveal-trigger"
      align={isRTL ? 'start' : 'end'}
      drop={drop}
    >
      <Dropdown.Toggle
        variant="reveal"
        size="sm"
        data-boundary="viewport"
        className={classNames('text-600', {
          [btnRevealClass ?? '']: btnRevealClass,
          'btn-reveal': !btnRevealClass,
        })}
      >
        {iconEl ? iconEl : <FontAwesomeIcon icon={icon} className="fs--2" />}
      </Dropdown.Toggle>
      <Dropdown.Menu className="border py-0">
        {children}
        {!children && (
          <div className="0">
            <Dropdown.Item className="link-600 fs--1 d-flex align-items-center gap-2 py-2">
              <div className="d-flex justify-content-center align-center w-25">
                <FontAwesomeIcon icon="eye" />
              </div>
              <a href="/" target="_blank" rel="noreferrer">
                مشاهده
              </a>
            </Dropdown.Item>
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CardDropdown;
